import React from "react";
import Context from "./context.js";
import axios from "axios";
import "@kenshooui/react-multi-select/dist/style.css"
import Component from "@reactions/component";
import host from "./host";
import Cookies from "universal-cookie";
import { Pane, Spinner, Dialog, Textarea, Label } from 'evergreen-ui'
import { FaArrowCircleLeft, FaPhone, FaUser, FaMapMarkerAlt, FaBoxes, FaClock, FaCheckCircle, FaEdit, FaChevronRight, FaChevronLeft, FaSearch, FaTimes } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { FcMissedCall, FcApproval, FcCancel } from "react-icons/fc";
import * as moment from "moment-timezone";
import { Link } from 'react-router-dom';

const cookies = new Cookies();

const styles = {
    container: {
        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        minHeight: '100vh',
        padding: '0',
        fontFamily: 'Cairo, Arial, sans-serif'
    },
    header: {
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '0 0 30px 30px',
        padding: '25px',
        margin: '0 10px 20px 10px',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
        border: '1px solid rgba(255, 255, 255, 0.2)'
    },
    headerContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '20px'
    },
    backButton: {
        background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
        color: 'white',
        border: 'none',
        borderRadius: '50%',
        width: '55px',
        height: '55px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '22px',
        boxShadow: '0 6px 20px rgba(79, 172, 254, 0.4)',
        transition: 'all 0.3s ease',
        cursor: 'pointer'
    },
    title: {
        color: '#2d3748',
        fontSize: '26px',
        fontWeight: 'bold',
        textAlign: 'center',
        flex: 1,
        margin: '0 20px'
    },
    statsContainer: {
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '25px',
        padding: '20px',
        margin: '0 10px 20px 10px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        textAlign: 'center'
    },
    counterBadge: {
        background: 'linear-gradient(45deg, #ff6b6b, #ee5a52)',
        color: 'white',
        padding: '12px 24px',
        borderRadius: '30px',
        fontSize: '18px',
        fontWeight: 'bold',
        boxShadow: '0 6px 20px rgba(255, 107, 107, 0.3)',
        display: 'inline-block'
    },
    orderCard: {
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '25px',
        boxShadow: '0 15px 45px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        margin: '15px',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        position: 'relative'
    },
    orderHeader: {
        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        color: 'white',
        padding: '25px',
        textAlign: 'center',
        borderRadius: '25px 25px 0 0',
        position: 'relative'
    },
    orderNumber: {
        fontSize: '22px',
        fontWeight: 'bold',
        marginBottom: '8px'
    },
    orderBody: {
        padding: '25px'
    },
    section: {
        background: '#f8fafc',
        borderRadius: '20px',
        padding: '20px',
        margin: '15px 0',
        border: '1px solid #e2e8f0',
        position: 'relative'
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '15px',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#2d3748'
    },
    sectionIcon: {
        background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
        color: 'white',
        borderRadius: '50%',
        width: '35px',
        height: '35px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px'
    },
    contactButtons: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '12px',
        margin: '15px 0'
    },
    contactButton: {
        padding: '15px',
        borderRadius: '15px',
        border: 'none',
        fontWeight: 'bold',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        transition: 'all 0.3s ease',
        cursor: 'pointer'
    },
    phoneButton: {
        background: 'linear-gradient(45deg, #4299e1, #3182ce)',
        color: 'white',
        boxShadow: '0 6px 20px rgba(66, 153, 225, 0.3)'
    },
    whatsappButton: {
        background: 'linear-gradient(45deg, #48bb78, #38a169)',
        color: 'white',
        boxShadow: '0 6px 20px rgba(72, 187, 120, 0.3)'
    },
    infoGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '12px'
    },
    infoCard: {
        background: 'white',
        padding: '15px',
        borderRadius: '12px',
        textAlign: 'center',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.3s ease'
    },
    infoLabel: {
        fontSize: '12px',
        color: '#718096',
        marginBottom: '6px',
        fontWeight: '500'
    },
    infoValue: {
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#2d3748'
    },
    itemCard: {
        background: 'white',
        padding: '12px',
        borderRadius: '10px',
        margin: '8px 0',
        border: '1px solid #e2e8f0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.3s ease'
    },
    itemName: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#2d3748'
    },
    itemCount: {
        background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
        color: 'white',
        padding: '4px 10px',
        borderRadius: '15px',
        fontSize: '12px',
        fontWeight: 'bold'
    },
    actionButtons: {
        background: '#f8fafc',
        padding: '20px',
        borderRadius: '0 0 25px 25px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
        gap: '12px'
    },
    actionButton: {
        padding: '12px 16px',
        borderRadius: '12px',
        border: 'none',
        fontWeight: 'bold',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
        color: 'white',
        minHeight: '50px',
        width: '100%'
    },
    noAnswerButton: {
        background: 'linear-gradient(45deg, #ed8936, #dd6b20)'
    },
    confirmButton: {
        background: 'linear-gradient(45deg, #48bb78, #38a169)'
    },
    editButton: {
        background: 'linear-gradient(45deg, #4299e1, #3182ce)'
    },
    cancelButton: {
        background: 'linear-gradient(45deg, #e53e3e, #c53030)'
    },
    loadingContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '25px',
        margin: '20px'
    },
    confirmLabel: {
        background: 'linear-gradient(45deg, #48bb78, #38a169)',
        color: 'white',
        padding: '8px 16px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: 'bold',
        position: 'absolute',
        top: '15px',
        right: '15px'
    },
    // ✅ Search Styles
    searchContainer: {
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '25px',
        padding: '20px',
        margin: '0 10px 20px 10px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)'
    },
    searchWrapper: {
        display: 'flex',
        gap: '12px',
        alignItems: 'center',
        flexWrap: 'wrap'
    },
    searchInput: {
        flex: 1,
        minWidth: '200px',
        padding: '15px 20px',
        borderRadius: '15px',
        border: '2px solid #e2e8f0',
        fontSize: '16px',
        fontFamily: 'Cairo, Arial, sans-serif',
        outline: 'none',
        transition: 'all 0.3s ease',
        direction: 'rtl'
    },
    searchButton: {
        background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
        color: 'white',
        border: 'none',
        borderRadius: '15px',
        padding: '15px 30px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        transition: 'all 0.3s ease',
        boxShadow: '0 6px 20px rgba(79, 172, 254, 0.3)'
    },
    clearButton: {
        background: 'linear-gradient(45deg, #e53e3e, #c53030)',
        color: 'white',
        border: 'none',
        borderRadius: '15px',
        padding: '15px 20px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        transition: 'all 0.3s ease',
        boxShadow: '0 6px 20px rgba(229, 62, 62, 0.3)'
    },
    searchLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '12px',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#2d3748'
    },
    searchResultBadge: {
        background: 'linear-gradient(45deg, #48bb78, #38a169)',
        color: 'white',
        padding: '8px 16px',
        borderRadius: '20px',
        fontSize: '14px',
        fontWeight: 'bold',
        marginTop: '12px',
        display: 'inline-block'
    },
    // ✅ Pagination Styles
    paginationContainer: {
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '25px',
        padding: '20px 30px',
        margin: '20px 10px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '15px',
        flexWrap: 'wrap'
    },
    paginationButton: {
        background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
        color: 'white',
        border: 'none',
        borderRadius: '12px',
        padding: '12px 20px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 15px rgba(79, 172, 254, 0.3)'
    },
    paginationButtonDisabled: {
        background: '#cbd5e0',
        cursor: 'not-allowed',
        boxShadow: 'none'
    },
    paginationInfo: {
        background: '#f7fafc',
        padding: '12px 24px',
        borderRadius: '12px',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#2d3748',
        border: '2px solid #e2e8f0'
    },
    paginationNumbers: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center'
    },
    pageNumber: {
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        border: '2px solid #e2e8f0',
        background: 'white',
        color: '#2d3748',
        fontSize: '14px',
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease'
    },
    pageNumberActive: {
        background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
        color: 'white',
        border: '2px solid transparent'
    }
};

const mediaQueries = `
  @media (max-width: 768px) {
    .order-grid {
      grid-template-columns: 1fr !important;
    }
    .header-content {
      flex-direction: column;
      text-align: center;
    }
    .contact-buttons {
      grid-template-columns: 1fr !important;
    }
    .info-grid {
      grid-template-columns: 1fr !important;
    }
    .action-buttons {
      grid-template-columns: 1fr 1fr !important;
      gap: 10px !important;
    }
    .pagination-container {
      flex-direction: column;
      gap: 10px;
    }
  }
  
  @media (max-width: 480px) {
    .action-buttons {
      grid-template-columns: 1fr !important;
      gap: 8px !important;
    }
  }
`;

class Orders extends React.Component {
    constructor() {
        super();
        this.state = {
            items: [],
            data: [],
            count: 0,
            spinPage: true,
            // ✅ Pagination State
            page: 1,
            totalPages: 1,
            total: 0,
            limit: 20,
            // ✅ Search State
            searchValue: '',
            isSearching: false
        };
    }

    componentDidMount() {
        this.fetchOrders(1);
    }

    // ✅ Fetch Orders with Pagination & Search
    fetchOrders = (page, search = '') => {
        this.setState({ spinPage: true });
        
        const { limit } = this.state;
        const searchQuery = search || this.state.searchValue;
        var header = { "Content-Type": "application/json", Authorization: cookies.get("token") };

        let url = `users/all/ordrers/mynew?status=-2&page=${page}&limit=${limit}`;
        if (searchQuery) {
            url += `&search=${encodeURIComponent(searchQuery)}`;
        }

        axios.get(host + url, { headers: header })
            .then(res => {
                let arr = [];
                const orders = res.data.data.orders || [];
                
                for (let i = 0; i < orders.length; i++) {
                    let color = "";
                    const missCount = orders[i].miss_count || 0;
                    
                    if (missCount === 0) color = "#fffff";
                    if (missCount === 1) color = "#10abca59";
                    if (missCount === 2) color = "#105bca59";
                    if (missCount === 3) color = "#103fca59";
                    if (missCount === 4) color = "#6310ca59";
                    if (missCount === 5) color = "#af10ca59";
                    if (missCount === 6) color = "#ca104e59";
                    if (missCount === 7) color = "#ca661059";
                    if (missCount >= 8) color = "#ca101087";
                    
                    orders[i].color = color;
                    
                    // ✅ Safe check for ordersFormItems
                    if (orders[i].ordersFormItems && orders[i].ordersFormItems.length > 0) {
                        arr.push(orders[i]);
                    }
                }
                
                this.setState({
                    items: arr,
                    data: arr,
                    count: res.data.data.total || arr.length,
                    page: res.data.data.page || page,
                    totalPages: res.data.data.totalPages || 1,
                    total: res.data.data.total || arr.length,
                    spinPage: false,
                    isSearching: false
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({ spinPage: false, isSearching: false });
            });
    }

    // ✅ Handle Search
    handleSearch = () => {
        this.setState({ isSearching: true, page: 1 }, () => {
            this.fetchOrders(1, this.state.searchValue);
        });
    }

    // ✅ Handle Search Input Change
    handleSearchChange = (e) => {
        this.setState({ searchValue: e.target.value });
    }

    // ✅ Handle Search on Enter
    handleSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearch();
        }
    }

    // ✅ Clear Search
    clearSearch = () => {
        this.setState({ searchValue: '', page: 1 }, () => {
            this.fetchOrders(1, '');
        });
    }

    // ✅ Handle Page Change
    handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= this.state.totalPages) {
            this.fetchOrders(newPage);
            // Scroll to top
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    // ✅ Render Pagination Numbers
    renderPageNumbers = () => {
        const { page, totalPages } = this.state;
        const pages = [];
        
        let startPage = Math.max(1, page - 2);
        let endPage = Math.min(totalPages, page + 2);
        
        // Adjust if near start or end
        if (page <= 3) {
            endPage = Math.min(5, totalPages);
        }
        if (page >= totalPages - 2) {
            startPage = Math.max(1, totalPages - 4);
        }
        
        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <button
                    key={i}
                    style={{
                        ...styles.pageNumber,
                        ...(i === page ? styles.pageNumberActive : {})
                    }}
                    onClick={() => this.handlePageChange(i)}
                >
                    {i}
                </button>
            );
        }
        
        return pages;
    }

    miss(id) {
        var header = { "Content-Type": "application/x-www-form-urlencoded", Authorization: cookies.get("token") };
        axios.post(host + `users/order/miss/${id}`, { headers: header })
            .then(response => {
                window.alert('تم التحديث');
                this.fetchOrders(this.state.page);
            })
            .catch(error => { console.log(error) });
    }

    deleteSubscriptions(id, name, msg) {
        axios({
            method: 'post',
            url: host + 'users/web/orders/confirm',
            headers: { 'Authorization': cookies.get("token") },
            data: {
                status: 2,
                reject: msg,
                id: id,
            }
        }).then((response) => {
            window.alert(`تم الغاء الطلب رقم ${id} الطلب بأسم ${name}`);
            this.fetchOrders(this.state.page);
        }).catch((error) => {
            window.location.href = '/Error';
        });
    }

    editOrder(id) {
        window.location.href = `/getOrder?id=${id}`;
    }

    click_log(id, type) {
        axios({
            method: 'post',
            url: host + 'users/web/click/log',
            headers: { 'Authorization': cookies.get("token") },
            data: {
                status: type,
                id: id,
            }
        }).then((response) => {
        }).catch((error) => {
        });
    }

    render() {
        const { page, totalPages, total, data, spinPage, count } = this.state;

        return (
            <div style={styles.container}>
                <style>{mediaQueries}</style>
                <Context.Consumer>
                    {ctx => {
                        return (
                            <div>
                                {/* Header */}
                                <div style={styles.header}>
                                    <div style={styles.headerContent} className="header-content">
                                        <Link to='/'>
                                            <button style={styles.backButton}>
                                                <FaArrowCircleLeft />
                                            </button>
                                        </Link>
                                        <h1 style={styles.title}>قائمة تأكيد الطلبات</h1>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <FaCheckCircle style={{ color: '#48bb78', fontSize: '24px' }} />
                                        </div>
                                    </div>
                                </div>

                                {/* Stats */}
                                <div style={styles.statsContainer}>
                                    <div style={styles.counterBadge}>
                                        عدد الطلبات المطلوب تأكيدها: {total}
                                    </div>
                                </div>

                                {/* ✅ Search Section */}
                                <div style={styles.searchContainer}>
                                    <div style={styles.searchLabel}>
                                        <FaSearch style={{ color: '#4facfe' }} />
                                        بحث عن طلب
                                    </div>
                                    <div style={styles.searchWrapper}>
                                        <input
                                            type="text"
                                            placeholder="ادخل رقم الوصل أو رقم الهاتف..."
                                            value={this.state.searchValue}
                                            onChange={this.handleSearchChange}
                                            onKeyPress={this.handleSearchKeyPress}
                                            style={styles.searchInput}
                                        />
                                        <button
                                            style={styles.searchButton}
                                            onClick={this.handleSearch}
                                            disabled={this.state.isSearching}
                                        >
                                            {this.state.isSearching ? (
                                                <Spinner size={16} />
                                            ) : (
                                                <>
                                                    <FaSearch />
                                                    بحث
                                                </>
                                            )}
                                        </button>
                                        {this.state.searchValue && (
                                            <button
                                                style={styles.clearButton}
                                                onClick={this.clearSearch}
                                            >
                                                <FaTimes />
                                                مسح
                                            </button>
                                        )}
                                    </div>
                                    {this.state.searchValue && !spinPage && (
                                        <div style={styles.searchResultBadge}>
                                            نتائج البحث عن "{this.state.searchValue}": {total} طلب
                                        </div>
                                    )}
                                </div>

                                {/* ✅ Pagination - Top */}
                                {totalPages > 1 && !spinPage && (
                                    <div style={styles.paginationContainer} className="pagination-container">
                                        <button
                                            style={{
                                                ...styles.paginationButton,
                                                ...(page === 1 ? styles.paginationButtonDisabled : {})
                                            }}
                                            onClick={() => this.handlePageChange(page - 1)}
                                            disabled={page === 1}
                                        >
                                            <FaChevronRight />
                                            السابق
                                        </button>
                                        
                                        <div style={styles.paginationNumbers}>
                                            {page > 3 && totalPages > 5 && (
                                                <>
                                                    <button
                                                        style={styles.pageNumber}
                                                        onClick={() => this.handlePageChange(1)}
                                                    >
                                                        1
                                                    </button>
                                                    <span style={{ color: '#718096' }}>...</span>
                                                </>
                                            )}
                                            
                                            {this.renderPageNumbers()}
                                            
                                            {page < totalPages - 2 && totalPages > 5 && (
                                                <>
                                                    <span style={{ color: '#718096' }}>...</span>
                                                    <button
                                                        style={styles.pageNumber}
                                                        onClick={() => this.handlePageChange(totalPages)}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                        
                                        <div style={styles.paginationInfo}>
                                            صفحة {page} من {totalPages}
                                        </div>
                                        
                                        <button
                                            style={{
                                                ...styles.paginationButton,
                                                ...(page === totalPages ? styles.paginationButtonDisabled : {})
                                            }}
                                            onClick={() => this.handlePageChange(page + 1)}
                                            disabled={page === totalPages}
                                        >
                                            التالي
                                            <FaChevronLeft />
                                        </button>
                                    </div>
                                )}

                                {/* Orders */}
                                {!spinPage ? (
                                    <div style={{ padding: '0 10px' }}>
                                        <div style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
                                            gap: '20px'
                                        }} className="order-grid">
                                            {data.map((item, index) => (
                                                <div key={index} style={styles.orderCard}>
                                                    {/* Confirm Label */}
                                                    <div style={styles.confirmLabel}>
                                                        يحتاج تأكيد
                                                    </div>

                                                    {/* Order Header */}
                                                    <div style={styles.orderHeader}>
                                                        <div style={styles.orderNumber}>
                                                            رقم الوصل: {item.id}
                                                        </div>
                                                    </div>

                                                    <div style={styles.orderBody}>
                                                        {/* Contact Section */}
                                                        <div style={styles.section}>
                                                            <div style={styles.sectionHeader}>
                                                                <div style={styles.sectionIcon}>
                                                                    <FaPhone />
                                                                </div>
                                                                معلومات التواصل
                                                            </div>
                                                            <div style={styles.contactButtons} className="contact-buttons">
                                                                <button
                                                                    style={{ ...styles.contactButton, ...styles.phoneButton }}
                                                                    onClick={() => {
                                                                        this.click_log(item.id, 'phone');
                                                                        window.location.href = `tel:${item.phone}`;
                                                                    }}
                                                                >
                                                                    <FaPhone />
                                                                    {item.phone}
                                                                </button>
                                                                <button
                                                                    style={{ ...styles.contactButton, ...styles.whatsappButton }}
                                                                    onClick={() => {
                                                                        window.location.replace(`https://api.whatsapp.com/send?phone=964${item.phone.slice(1)}`);
                                                                        this.click_log(item.id, 'whatssap');
                                                                    }}
                                                                >
                                                                    <IoLogoWhatsapp />
                                                                    واتساب
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {/* Customer Info */}
                                                        <div style={styles.section}>
                                                            <div style={styles.sectionHeader}>
                                                                <div style={styles.sectionIcon}>
                                                                    <FaUser />
                                                                </div>
                                                                معلومات الزبون
                                                            </div>
                                                            <div style={styles.infoGrid} className="info-grid">
                                                                <div style={styles.infoCard}>
                                                                    <div style={styles.infoLabel}>اسم الزبون</div>
                                                                    <div style={styles.infoValue}>{item.name}</div>
                                                                </div>
                                                                <div style={styles.infoCard}>
                                                                    <div style={styles.infoLabel}>اسم البيج</div>
                                                                    <div style={styles.infoValue}>{item.page_name}</div>
                                                                </div>
                                                                <div style={styles.infoCard}>
                                                                    <div style={styles.infoLabel}>السعر الكلي</div>
                                                                    <div style={styles.infoValue}>{item.price}</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Items */}
                                                        <div style={styles.section}>
                                                            <div style={styles.sectionHeader}>
                                                                <div style={styles.sectionIcon}>
                                                                    <FaBoxes />
                                                                </div>
                                                                المواد المطلوبة
                                                            </div>
                                                            {item.ordersFormItems && item.ordersFormItems.map((orderItem, i) => (
                                                                <div key={i} style={styles.itemCard}>
                                                                    <div style={styles.itemName}>
                                                                        {orderItem.components?.name || 'غير محدد'}
                                                                    </div>
                                                                    <div style={styles.itemCount}>
                                                                        العدد: {orderItem.count}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {/* Address */}
                                                        <div style={styles.section}>
                                                            <div style={styles.sectionHeader}>
                                                                <div style={styles.sectionIcon}>
                                                                    <FaMapMarkerAlt />
                                                                </div>
                                                                العنوان
                                                            </div>
                                                            <div style={styles.infoValue}>
                                                                {item.government} / {item.city}
                                                            </div>
                                                        </div>

                                                        {/* Dates */}
                                                        <div style={styles.section}>
                                                            <div style={styles.sectionHeader}>
                                                                <div style={styles.sectionIcon}>
                                                                    <FaClock />
                                                                </div>
                                                                التواريخ
                                                            </div>
                                                            <div style={styles.infoGrid} className="info-grid">
                                                                <div style={styles.infoCard}>
                                                                    <div style={styles.infoLabel}>وقت الحجز</div>
                                                                    <div style={styles.infoValue}>
                                                                        {moment(item.createdAt).tz("Asia/Baghdad").format('DD/MM/YYYY LT')}
                                                                    </div>
                                                                </div>
                                                                <div style={styles.infoCard}>
                                                                    <div style={styles.infoLabel}>آخر تحديث</div>
                                                                    <div style={styles.infoValue}>
                                                                        {moment(item.updatedAt).tz("Asia/Baghdad").format('DD/MM/YYYY LT')}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Action Buttons */}
                                                    <div style={styles.actionButtons} className="action-buttons">
                                                        {/* Confirm Button */}
                                                        <Component initialState={{ isShown: false, items: [], notes: "", spin: true }}>
                                                            {({ state, setState }) => (
                                                                <Pane>
                                                                    <Dialog
                                                                        isShown={state.isShown}
                                                                        onCloseComplete={() => setState({ isShown: false })}
                                                                        confirmLabel="تأكيد الطلب"
                                                                        intent="success"
                                                                        hasFooter={true}
                                                                        title={"تأكيد الطلب"}
                                                                        onConfirm={() => {
                                                                            axios({
                                                                                method: 'post',
                                                                                url: host + 'users/web/orders/confirm',
                                                                                headers: { 'Authorization': cookies.get("token") },
                                                                                data: {
                                                                                    status: 1,
                                                                                    notes: state.notes,
                                                                                    id: item.id,
                                                                                }
                                                                            }).then((response) => {
                                                                                window.alert(`تم تأكيد الطلب رقم ${item.id} الطلب بأسم ${item.name}`);
                                                                                setState({ isShown: false, notes: "" });
                                                                                this.fetchOrders(this.state.page);
                                                                            }).catch((error) => {
                                                                                setState({ isShown: false, notes: "" });
                                                                                window.location.href = '/Error';
                                                                            });
                                                                        }}
                                                                    >
                                                                        <div style={{ direction: 'rtl', textAlign: 'right' }}>
                                                                            {!state.spin ? (
                                                                                <div>
                                                                                    <div style={styles.section}>
                                                                                        <div style={styles.infoGrid}>
                                                                                            <div style={styles.infoCard}>
                                                                                                <div style={styles.infoLabel}>رقم الوصل</div>
                                                                                                <div style={styles.infoValue}>{item.id}</div>
                                                                                            </div>
                                                                                            <div style={styles.infoCard}>
                                                                                                <div style={styles.infoLabel}>اسم الزبون</div>
                                                                                                <div style={styles.infoValue}>{item.name}</div>
                                                                                            </div>
                                                                                            <div style={styles.infoCard}>
                                                                                                <div style={styles.infoLabel}>العنوان</div>
                                                                                                <div style={styles.infoValue}>{item.government + " / " + item.city}</div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <Label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
                                                                                        ملاحظات
                                                                                    </Label>
                                                                                    <Textarea
                                                                                        id="notes"
                                                                                        value={state.notes}
                                                                                        name="textarea-1"
                                                                                        placeholder="الملاحظات ان وجدت"
                                                                                        style={{
                                                                                            minHeight: '100px',
                                                                                            border: '2px solid #e2e8f0',
                                                                                            borderRadius: '12px'
                                                                                        }}
                                                                                        onChange={(e) => setState({ notes: e.target.value })}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div style={styles.loadingContainer}>
                                                                                    <Spinner />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </Dialog>
                                                                    <button
                                                                        style={{
                                                                            ...styles.actionButton,
                                                                            ...styles.confirmButton,
                                                                            display: item.ordersFormItems?.[0]?.components?.id !== 68 ? 'flex' : 'none'
                                                                        }}
                                                                        onClick={() => {
                                                                            setState({ isShown: true, spin: true });
                                                                            axios.get(host + `users/all/ordrers/order/${item.id}`, { 
                                                                                headers: { "Content-Type": "application/json", Authorization: cookies.get("token") } 
                                                                            })
                                                                            .then(res => {
                                                                                setState({ isShown: true, spin: false, items: res.data.data.order });
                                                                            })
                                                                            .catch(error => console.log(error));
                                                                        }}
                                                                    >
                                                                        <FcApproval />
                                                                        تأكيد الطلب
                                                                    </button>
                                                                </Pane>
                                                            )}
                                                        </Component>

                                                        {/* No Answer Button */}
                                                        <Component initialState={{ isShown: false, items: [], notes: "", spin: true }}>
                                                            {({ state, setState }) => (
                                                                <Pane>
                                                                    <Dialog
                                                                        isShown={state.isShown}
                                                                        onCloseComplete={() => setState({ isShown: false })}
                                                                        confirmLabel="جعله لايرد"
                                                                        intent="warning"
                                                                        hasFooter={true}
                                                                        title={"تحديد الطلب لايرد"}
                                                                        onConfirm={() => {
                                                                            axios({
                                                                                method: 'post',
                                                                                url: host + 'users/web/orders/confirm',
                                                                                headers: { 'Authorization': cookies.get("token") },
                                                                                data: {
                                                                                    status: 3,
                                                                                    id: item.id,
                                                                                }
                                                                            }).then((response) => {
                                                                                window.alert(`تم تحديد كـ لايرد الطلب رقم ${item.id} الطلب بأسم ${item.name}`);
                                                                                setState({ isShown: false, notes: "" });
                                                                                this.fetchOrders(this.state.page);
                                                                            }).catch((error) => {
                                                                                setState({ isShown: false, notes: "" });
                                                                                window.location.href = '/Error';
                                                                            });
                                                                        }}
                                                                    >
                                                                        <div style={{ direction: 'rtl', textAlign: 'right' }}>
                                                                            {!state.spin ? (
                                                                                <div>
                                                                                    <div style={styles.section}>
                                                                                        <div style={styles.infoGrid}>
                                                                                            <div style={styles.infoCard}>
                                                                                                <div style={styles.infoLabel}>رقم الوصل</div>
                                                                                                <div style={styles.infoValue}>{item.id}</div>
                                                                                            </div>
                                                                                            <div style={styles.infoCard}>
                                                                                                <div style={styles.infoLabel}>اسم الزبون</div>
                                                                                                <div style={styles.infoValue}>{item.name}</div>
                                                                                            </div>
                                                                                            <div style={styles.infoCard}>
                                                                                                <div style={styles.infoLabel}>العنوان</div>
                                                                                                <div style={styles.infoValue}>{item.government + " / " + item.city}</div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <div style={styles.loadingContainer}>
                                                                                    <Spinner />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </Dialog>
                                                                    <button
                                                                        style={{ ...styles.actionButton, ...styles.noAnswerButton }}
                                                                        onClick={() => {
                                                                            setState({ isShown: true, spin: true });
                                                                            axios.get(host + `users/all/ordrers/order/${item.id}`, { 
                                                                                headers: { 'Authorization': cookies.get("token") } 
                                                                            })
                                                                            .then(res => {
                                                                                setState({ isShown: true, spin: false, items: res.data.data.order });
                                                                            })
                                                                            .catch(error => console.log(error));
                                                                        }}
                                                                    >
                                                                        <FcMissedCall />
                                                                        لا يرد
                                                                    </button>
                                                                </Pane>
                                                            )}
                                                        </Component>

                                                        {/* Edit Button */}
                                                        <button
                                                            style={{ ...styles.actionButton, ...styles.editButton }}
                                                            onClick={() => this.editOrder(item.id)}
                                                        >
                                                            <FaEdit />
                                                            تعديل الطلب
                                                        </button>

                                                        {/* Cancel Button */}
                                                        <Component initialState={{ isShown: false, notes: "" }}>
                                                            {({ state, setState }) => (
                                                                <Pane>
                                                                    <Dialog
                                                                        isShown={state.isShown}
                                                                        title="الغاء الطلب"
                                                                        intent="danger"
                                                                        onCloseComplete={() => setState({ isShown: false })}
                                                                        confirmLabel="تاكيد"
                                                                        cancelLabel='الغاء'
                                                                        onConfirm={() => {
                                                                            if (!state.notes) {
                                                                                window.alert('ادخل سبب الالغاء');
                                                                                return -1;
                                                                            } else {
                                                                                this.deleteSubscriptions(item.id, item.name, state.notes);
                                                                                setState({ isShown: false, notes: '' });
                                                                            }
                                                                        }}
                                                                    >
                                                                        <div style={{ direction: 'rtl', textAlign: 'right' }}>
                                                                            <div style={styles.section}>
                                                                                <div style={styles.sectionHeader}>
                                                                                    <div style={styles.sectionIcon}>
                                                                                        <FcCancel />
                                                                                    </div>
                                                                                    تأكيد الالغاء
                                                                                </div>
                                                                                <div style={{
                                                                                    background: '#fed7d7',
                                                                                    border: '1px solid #fc8181',
                                                                                    borderRadius: '12px',
                                                                                    padding: '15px',
                                                                                    marginBottom: '15px'
                                                                                }}>
                                                                                    <strong>تحذير:</strong> سيتم الغاء الطلب رقم {item.id} نهائياً
                                                                                </div>
                                                                            </div>
                                                                            <Label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
                                                                                سبب الالغاء *
                                                                            </Label>
                                                                            <Textarea
                                                                                dir="rtl"
                                                                                id="notes"
                                                                                value={state.notes}
                                                                                name="textarea-1"
                                                                                placeholder="اكتب سبب الالغاء..."
                                                                                style={{
                                                                                    minHeight: '100px',
                                                                                    border: '2px solid #e2e8f0',
                                                                                    borderRadius: '12px'
                                                                                }}
                                                                                onChange={(e) => setState({ notes: e.target.value })}
                                                                            />
                                                                        </div>
                                                                    </Dialog>
                                                                    <button
                                                                        style={{ ...styles.actionButton, ...styles.cancelButton }}
                                                                        onClick={() => setState({ isShown: true })}
                                                                    >
                                                                        <FcCancel />
                                                                        الغاء الطلب
                                                                    </button>
                                                                </Pane>
                                                            )}
                                                        </Component>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* ✅ Pagination - Bottom */}
                                        {totalPages > 1 && (
                                            <div style={styles.paginationContainer} className="pagination-container">
                                                <button
                                                    style={{
                                                        ...styles.paginationButton,
                                                        ...(page === 1 ? styles.paginationButtonDisabled : {})
                                                    }}
                                                    onClick={() => this.handlePageChange(page - 1)}
                                                    disabled={page === 1}
                                                >
                                                    <FaChevronRight />
                                                    السابق
                                                </button>
                                                
                                                <div style={styles.paginationNumbers}>
                                                    {page > 3 && totalPages > 5 && (
                                                        <>
                                                            <button
                                                                style={styles.pageNumber}
                                                                onClick={() => this.handlePageChange(1)}
                                                            >
                                                                1
                                                            </button>
                                                            <span style={{ color: '#718096' }}>...</span>
                                                        </>
                                                    )}
                                                    
                                                    {this.renderPageNumbers()}
                                                    
                                                    {page < totalPages - 2 && totalPages > 5 && (
                                                        <>
                                                            <span style={{ color: '#718096' }}>...</span>
                                                            <button
                                                                style={styles.pageNumber}
                                                                onClick={() => this.handlePageChange(totalPages)}
                                                            >
                                                                {totalPages}
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                                
                                                <div style={styles.paginationInfo}>
                                                    صفحة {page} من {totalPages}
                                                </div>
                                                
                                                <button
                                                    style={{
                                                        ...styles.paginationButton,
                                                        ...(page === totalPages ? styles.paginationButtonDisabled : {})
                                                    }}
                                                    onClick={() => this.handlePageChange(page + 1)}
                                                    disabled={page === totalPages}
                                                >
                                                    التالي
                                                    <FaChevronLeft />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div style={styles.loadingContainer}>
                                        <Spinner size={48} />
                                    </div>
                                )}
                            </div>
                        )
                    }}
                </Context.Consumer>
            </div>
        );
    }
}

export default Orders;
